class Single {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const listTxtWrap = document.querySelectorAll(".js-single-list-txt")




    listTxtWrap.forEach(txtWrap => {
      const txt = txtWrap.querySelectorAll("p")
      txt.forEach(ele => {

        if(!ele.textContent.match(/\S/g)){
          ele.classList.add("is-space")
        }

      })
    })


  }
}
